/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_New_PhInputs */

const en_dr_pick_new_ph = /** @type {(inputs: Dr_Pick_New_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace name, e.g. Salon Sari`)
};

const id_dr_pick_new_ph = /** @type {(inputs: Dr_Pick_New_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama workspace, mis. Salon Sari`)
};

/**
* | output |
* | --- |
* | "Workspace name, e.g. Salon Sari" |
*
* @param {Dr_Pick_New_PhInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_new_ph = /** @type {((inputs?: Dr_Pick_New_PhInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_New_PhInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_new_ph(inputs)
	return en_dr_pick_new_ph(inputs)
});